import { render, staticRenderFns } from "./main-service-cn.vue?vue&type=template&id=7619b6fc&"
import script from "./main-service-cn.vue?vue&type=script&lang=js&"
export * from "./main-service-cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports